import { render, staticRenderFns } from "./Presale.vue?vue&type=template&id=1d24cc66"
import script from "./Presale.vue?vue&type=script&lang=js"
export * from "./Presale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports